module.exports = __webpack_public_path__ + "img/2_163.68bd946b.png";